import { useTheme } from '@emotion/react';
import type { FunctionComponent } from 'react';
import { useMemo } from 'react';

import { htmlDiffer } from '../../app/common/html-differ';
import { DescriptionSection } from '../job-profile-section/EditableDescription';

export const DescriptionDiff: FunctionComponent<{
    readonly against?: string;
    readonly current?: string;
    readonly title: string;
    readonly type: 'added' | 'removed';
}> = ({ against, current, title, type }) => {
    const theme = useTheme();

    const diff = useMemo(
        () =>
            htmlDiffer({
                compareAgainst: against ?? '',
                current: current ?? '',
                theme,
                type,
            }),
        [current, against, theme, type],
    );

    return <DescriptionSection commentable={false} title={title} value={diff} />;
};
